import { userReducer } from "./user/reducer";
import { loginReducer, passwordReducer } from "./login/reducer";
import { workspaceLayoutReducer } from "./workspaceLayout/reducer";

export const reducer = {
  user: userReducer,
  login: loginReducer,
  password: passwordReducer,
  workspaceLayout: workspaceLayoutReducer
};
